<div class="market-pairs">

  <!-- <h2 class="heading">{{"market"|translate}}</h2> -->

  <div class="input-group mt-2">
    <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm" style="border-radius: 2px;"><i class="icon ion-md-search"></i></span>
    </div>
    <input type="text" class="form-control" style="height: auto; border-radius: 2px;" (keyup)="updateFilter($event)" placeholder="{{'search'|translate}}" />
    <div style="padding-inline-start:8px;">
      <mat-button-toggle-group *ngIf="tableView == 'favorites'" appearance="legacy" [value]="favView" #group="matButtonToggleGroup" (change)="onFavViewChange(group.value)">
        <mat-button-toggle value="grid">
          <mat-icon class="text-muted" style="font-size: 18px;vertical-align: middle">
            grid_view
          </mat-icon>
        </mat-button-toggle>
        <mat-button-toggle value="table">
          <mat-icon class="text-muted" style="font-size: 18px;vertical-align: middle">
            table_rows
          </mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div>
      <button style="border-radius: 50%" [matMenuTriggerFor]="menu" type="button" class="btn btn-dark" style="margin-inline-start: 10px">
        <i class="icon ion-ios-funnel"></i>
      </button>
      <button style="border-radius: 50%" [matMenuTriggerFor]="colMenu" type="button" class="btn btn-dark" style="margin-inline-start: 10px">
        <i class="icon ion-md-more"></i>
      </button>
      <mat-menu #menu="matMenu" class="mat-menu-panelcolors">
        <ul class="nav flex-column nav-pills" style="text-align: center" role="tablist">
          <li class="nav-item">
            <a class="nav-link" data-toggle="pill" (click)="fetchFavs()" role="tab" aria-selected="true">
              <mat-icon style="vertical-align: middle; font-size: 21px;">star</mat-icon> Favorites
            </a>
          </li>
          <hr style="background: #6c757d!important; width: 60%;">

          <li class="nav-item">
            <a class="nav-link" data-toggle="pill" (click)="fetchTodayActive()" role="tab" aria-selected="true">
              Most Active
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="fetchCompanies()" data-toggle="pill" role="tab" aria-selected="true">All
              Market</a>
          </li>

          <li class="nav-item">
            <a class="nav-link active" (click)="fetchEGX('EGX30')" data-toggle="pill" role="tab" aria-selected="false">EGX30</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="fetchEGX('EGX70')" data-toggle="pill" role="tab" aria-selected="false">EGX70</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="fetchEGX('EGX100')" data-toggle="pill" role="tab" aria-selected="false">EGX100</a>
          </li>

          <hr style="background: #6c757d!important; width: 60%;">

          <li class="nav-item">
            <a class="nav-link" (click)="fetchMarket('NOPL')" data-toggle="pill" role="tab" aria-selected="false">Main
              Market</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="fetchMarket('sme')" data-toggle="pill" role="tab" aria-selected="false">NileX</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="fetchMarket('OTC')" data-toggle="pill" role="tab" aria-selected="false">OTC</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="fetchMarket('SAMEDAY')" data-toggle="pill" role="tab" aria-selected="false">Same Day</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="fetchMarket('D')" data-toggle="pill" role="tab" aria-selected="false">5%
              Limit</a>
          </li>
        </ul>
      </mat-menu>
      <mat-menu #colMenu="matMenu" class="mat-menu-panelcolors">
        <div class="menuu">
          <div style="margin: 11px; text-align: start;">
            <strong>{{"aval-cols" | translate}}</strong>
          </div>
          <div cdkDropList (cdkDropListDropped)="drop($event)" style="margin: 4px">
            <div *ngFor="let col of columns" cdkDrag class="card">
              <div class="card-body form-switch d-flex align-items-center justify-content-between" style="padding: 10px; height: 30px;vertical-align: -webkit-baseline-middle ">
                <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="toggle(col, $event)" [checked]="col.isChecked" class="white-dark-smoke" style="margin: 0px !important;">
                  <label [attr.for]="col.name" class="white-dark-smoke" style="margin: 0px !important;">
                    <mat-icon class="text-muted" style="font-size: 22px;vertical-align: middle ;cursor: grab;">
                      drag_indicator
                    </mat-icon>
                    <span style="font-family: 'Almarai';padding-inline-start: 4px;">{{col.name | translate}}</span>
                  </label>
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </mat-menu>
    </div>
  </div>

  <div class=pb-1 id="recent-trades" #myWidget style="overflow:scroll">
    <div>
      <app-market-grid-view *ngIf="tableView=='favorites' && favCompanies && favView == 'grid'"></app-market-grid-view>
    </div>
    <ngx-datatable *ngIf="tableView=='favorites' && favCompanies && favView != 'grid'" [rowClass]="getRowClass" [reorderable]="true" (reorder)="reordered($event)" (tableContextmenu)="onTableContextMenu($event)" [selected]="selected" [selectionType]="SelectionType.single" (select)="onSelect($event)" style="height:100%" #myTable class="material expandable" [scrollbarV]="true" [scrollbarH]="true" columnMode="force" [headerHeight]="40" [rowHeight]="38" [loadingIndicator]="isCompaniesLoading" [rows]="searchComp != null ? searchComp : (tableView=='favorites')?favCompanies:companies">

      <!-- Row Detail Template -->
      <ngx-datatable-row-detail [rowHeight]="450" (toggle)="onDetailToggle($event)">
        <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
          <app-new-trade-chart [symbol]="row.SYMBOL_CODE"></app-new-trade-chart>
        </ng-template>
      </ngx-datatable-row-detail>

      <!-- Column Templates -->
      <ngx-datatable-column [cellClass]="getCellClass" [frozenLeft]="true" [draggable]="false" [width]="10" [resizeable]="false" [sortable]="false" [canAutoResize]="false">
        <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
          <a href="javascript:void(0)" [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="View Candlestick" (click)="toggleExpandRow(row)">
          </a>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [cellClass]="getCellClass" [frozenLeft]="true" [canAutoResize]="false" [width]="85" [draggable]="false" name="{{ 'reuters' | translate }}" prop="Reuters">
      </ngx-datatable-column>

      <ngx-datatable-column [cellClass]="getCellClass" [frozenLeft]="true" *ngIf="translate.currentLang == 'en'" [canAutoResize]="false" [draggable]="false" [width]="250" name="{{ 'symbol' | translate }}" prop="ENG_NAME">
      </ngx-datatable-column>

      <ngx-datatable-column *ngFor="let col of colsss" [width]="90" [cellClass]="getCellClass" name="{{ col.name | translate }}" pipe="{{col.pipe}}" prop="{{ col.prop }}">
        <ng-template let-value="value" ngx-datatable-cell-template>
          <span *ngIf="isNumber(value)">{{ value | number: "1.2-2":"en-US" }}</span>
          <span *ngIf="!isNumber(value)">{{ value }}</span>
          <span *ngIf="col.prop == 'LAST_CHANGE_PRC'">%</span>
        </ng-template>
      </ngx-datatable-column>

    </ngx-datatable>
    <app-context-menu (clickedOutside)="clickedOutsideMenu()" (addNew)="addWidgett($event)" [item]="addWidgetSymbolCode" [isShow]="contextmenu" [x]="contextmenuX" [y]="contextmenuY">
    </app-context-menu>


    <ngx-datatable [virtualization]="false" *ngIf="tableView=='market'" [rowClass]="getRowClass" [reorderable]="true" (reorder)="reordered($event)" (tableContextmenu)="onTableContextMenu($event)" [selected]="selected" [selectionType]="SelectionType.single" style="height:100%; " (select)="onSelect($event)" #myTable class="material expandable" [scrollbarV]="true" [scrollbarH]="true" [columnMode]="ColumnMode.force" [headerHeight]="40" [rowHeight]="38" [loadingIndicator]="isCompaniesLoading" [rows]="searchComp != null ? searchComp : companies">

      <ngx-datatable-row-detail [rowHeight]="450" (toggle)="onDetailToggle($event)">
        <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
          <app-new-trade-chart [symbol]="row.SYMBOL_CODE"></app-new-trade-chart>
        </ng-template>
      </ngx-datatable-row-detail>

      <ngx-datatable-column [frozenLeft]="true" [draggable]="false" [width]="35" [resizeable]="false" [sortable]="false" [canAutoResize]="false">
        <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
          <a href="javascript:void(0)" [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="View Candlestick" (click)="toggleExpandRow(row)">
          </a>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [frozenLeft]="true" [canAutoResize]="false" [resizeable]="false" [width]="75" [draggable]="false" name="{{ 'reuters' | translate }}" prop="Reuters">
      </ngx-datatable-column>

      <ngx-datatable-column [frozenLeft]="true" [canAutoResize]="false" [resizeable]="false" [draggable]="false" [width]="250" name="{{ 'symbol' | translate }}" [prop]="(translate.currentLang == 'en')?'ENG_NAME':'ARB_NAME'">
      </ngx-datatable-column>

      <ngx-datatable-column *ngFor="let col of colsss" name="{{ col.name | translate }}" pipe="{{col.pipe}}" prop="{{ col.prop }}" [width]="120">
        <ng-template let-value="value" ngx-datatable-cell-template>
          <span *ngIf="isNumber(value)" [ngClass]="{'green': (col.prop == 'LAST_CHANGE_PRC' && value> 0 ||
            col.prop == 'LAST_CHANGE' && value > 0), 'red' : (col.prop == 'LAST_CHANGE_PRC' && value <0 || col.prop=='LAST_CHANGE' && value <0)}">{{
            value | number: "1.2-2":"en-US" }}

            <span *ngIf="col.prop == 'LAST_CHANGE_PRC'">%</span>
          </span>
          <span *ngIf="!isNumber(value)">{{ value }}</span>
        </ng-template>
      </ngx-datatable-column>

    </ngx-datatable>
    <app-context-menu (clickedOutside)="clickedOutsideMenu()" (addNew)="addWidgett($event)" [item]="addWidgetSymbolCode" [isShow]="contextmenu" [x]="contextmenuX" [y]="contextmenuY">
    </app-context-menu>
  </div>
</div>
